export default "__VITE_ASSET__ffc45fcb__"